module.exports = __webpack_public_path__ + "img/imgtu.c236cb3e.jpg";